import * as React from 'react';
import './form-elements.scss';
import Select from 'react-select';
import { Label } from 'reactstrap';

const select = ({ options, labelKey, valueKey, label, input, id, simpleValue,  meta: { touched, error, initial } })  => {

  return (
    
    <div className="SelectField__FieldWrapper">
        <div className={`select-ct ${touched && error && 'has-error'}`}>
        <Select 
                {...input}
                options={options}
                id={id}
                aria-role="combobox"
                aria-owns={id}
                placeholder={''}
                valueKey={valueKey}
                labelKey={labelKey}
                resetValue={initial}
                onBlur={() => input.onBlur(input.value)}
                simpleValue={simpleValue === undefined ? true : simpleValue} 
                clearable={false}
                searchable={false}
            />
            {label !== '' && <Label className="Label__FloatedLabel" htmlFor={id}>{label}</Label>}
         </div>
        {touched && error && 
              // tslint:disable-next-line:max-line-length
         <div className="FieldError__ErrorContainer"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line></svg> {error}</div>
        }
    </div>
  );
};

export const SimplerSelect = select;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/_global/components/form-elements/simpler-select.tsx